import RightArrowExtendedIconSVG from "../../../SharedComponents/assets/icons/svg/RightArrowExtendedIconSVG";
import { getSrcUrlFromFile } from "../../../SharedComponents/utils/helpers/getSrcUrlFromFile";


const ReviewOffer = ({ formData, selectedImages, onBack, onSubmit }) => {
    return (
        <div style={styles.modalBackdrop}>
            <div style={styles.modalContainer}>
                <h1 style={styles.mainTitle}>Potvrdi detalje ponude i pošalji</h1>
                <div style={styles.container}>
                    {selectedImages.length > 0 && (
                        <div style={styles.imageGallery}>
                            <div style={styles.mainImageContainer}>
                                <img
                                    src={getSrcUrlFromFile(selectedImages[0])}
                                    style={styles.mainImage}
                                    alt="Main offer"
                                />
                            </div>

                            <div style={styles.thumbnailRow}>
                                {selectedImages.map((image, index) => (
                                    <div key={index} style={styles.thumbnailContainer}>
                                        <img
                                            src={getSrcUrlFromFile(image)}
                                            style={styles.thumbnail}
                                            alt={`Offer ${index + 1}`}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div style={styles.dataSection}>
                        <div style={styles.priceSection}>
                            <h2 style={styles.price}>{formData.price || "0"} {formData.currency?.toUpperCase() || "EUR"}</h2>
                            <p style={styles.subtitle}>
                                {formData.type === "nov" ? "Nov deo" : "Polovan deo"} -{" "}
                                {formData.guarantee ? `Garancija: ${formData.guarantee}` : "Bez garancije"}
                            </p>
                        </div>

                        <div style={styles.deliverySection}>
                            <p style={styles.deliveryText}>
                                {formData.deliveryOptions?.length
                                    ? `Dostava: ${formData.deliveryOptions.join(" ili ")}`
                                    : "Nije izabran način dostave"}
                            </p>
                        </div>

                        <div style={styles.descriptionSection}>
                            <p style={styles.descriptionText}>
                                {formData.description || "Nije dodat opis dela"}
                            </p>
                        </div>
                    </div>
                </div>
                <div style={styles.buttonGroup}>
                    <button
                        style={styles.backButton}
                        onClick={onBack}
                    >
                        Nazad
                    </button>
                    <button
                        style={styles.submitButton}
                        onClick={onSubmit}
                    >
                        Pošalji ponudu <RightArrowExtendedIconSVG style={styles.arrowIcon} />
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    modalBackdrop: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000
    },
    modalContainer: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "30px",
        width: "90%",
        maxWidth: "800px",
        maxHeight: "90vh",
        overflowY: "auto",
        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    },
    container: {
        fontFamily: "Arial, sans-serif",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    },
    mainTitle: {
        fontSize: "24px",
        fontWeight: "bold",
        color: "#333",
        marginBottom: "30px",
        textAlign: "center"
    },
    dataSection: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
    },
    priceSection: {
        marginBottom: "20px",
        textAlign: "center"
    },
    price: {
        fontSize: "28px",
        fontWeight: "bold",
        color: "#333",
        marginBottom: "5px"
    },
    subtitle: {
        fontSize: "16px",
        color: "black",
        fontWeight: "bold",
        marginTop: "5px"
    },
    deliverySection: {
        marginBottom: "25px",
        marginLeft: "25px"
    },
    deliveryText: {
        fontSize: "16px",
        color: "#333",
        fontWeight: "500"
    },
    descriptionSection: {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "30px"
    },
    descriptionText: {
        fontSize: "16px",
        color: "#333",
        lineHeight: "1.5",
        whiteSpace: "pre-wrap"
    },
    buttonGroup: {
        display: "flex",
        justifyContent: "space-between",
        gap: "20px"
    },
    backButton: {
        flex: 1,
        padding: "15px",
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
        color: "#333",
        border: "2px solid #ccc",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "background-color 0.2s"
    },
    submitButton: {
        flex: 1,
        padding: "15px",
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: "#000",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        transition: "background-color 0.2s"
    },
    arrowIcon: {
        width: "20px",
        height: "20px"
    },
    imageGallery: {
        marginBottom: "25px",
        width: "100%",
        display: "flex",
        flexDirection: "column"
    },
    mainImageContainer: {
        width: "100%",
        height: "300px",
        overflow: "hidden",
        borderRadius: "8px",
        marginBottom: "10px"
    },
    mainImage: {
        width: "100%",
        height: "100%",
        objectFit: "contain"
    },
    thumbnailRow: {
        display: "flex",
        gap: "10px",
        justifyContent: "center"
    },
    thumbnailContainer: {
        width: "100px",
        height: "100px",
        overflow: "hidden",
        borderRadius: "8px"
    },
    thumbnail: {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    }
};

export default ReviewOffer;
